
import React from 'react';
import { useSelector  } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import {
    IfComp,
    PanelTitle,
    Tabs
} from '../../../core';

import { getDataProjectId } from '../../../project';

import useDataModelDefinition from '../../hooks/useDataModelDefinition';
import useDatawinDataModelItem from '../../hooks/useDatawinDataModelItem';

import WindowSwitcher from '../../../app/components/WindowSwitcher';

import DataWindowHeader from './DataWindowHeader';
import FetchObjectsPanel from './FetchObjectsPanel';
import ObjectPanel from './ObjectPanel';
import ObjectListPanel from './ObjectListPanel';

const DataWindow = ({appActions, appConfig, tabs, windowList}) => {

    const classNames = mergeStyleSets({
        DataWindow: {
        },
        content: {
            paddingTop: 4
        },
        header: {
            paddingLeft: 12,

        }
    });

    const [selection, setSelection] = React.useState();
    const dataProjectId = useSelector(state => getDataProjectId(state.project));
    const dataModelDefinition = useDataModelDefinition(dataProjectId);
    const dataModelItem = useDatawinDataModelItem();

    const handleSelectionChanged = (selection) => {
        setSelection(selection);
    }

    const handleTabClick = (name) => {
        appActions.setUiValue('activeWindow', 'map');
        appActions.setUiValue('activePanelName', name);
    }

    const getTabsAdditionalContent = () => {
        return (
            <WindowSwitcher
                activeWindow="data"
                appActions={appActions}
                windowList={windowList}
            />
        );
    }

    return (
        <Stack horizontal verticalFill className={classNames.DataWindow} >
            <Tabs
                active="data"
                additionalContent={getTabsAdditionalContent()}
                onClick={handleTabClick}
            >
                {tabs.map(item => {
                    const props = {...item, key: item.name};
                    return (
                        <x {...props} />
                     )
                })}
            </Tabs>
            <Stack.Item grow>
                <Stack verticalFill className={classNames.content}>
                    <Stack.Item className={classNames.header}>
                        <PanelTitle title="DATOVÉ OKNO" />
                    </Stack.Item>
                    <IfComp cond={dataModelDefinition.dataModelDefinition}>
                        <DataWindowHeader
                            appActions={appActions}
                            selection={selection}
                        />
                        <Stack.Item grow>
                            <Stack horizontal verticalFill>
                                <IfComp cond={dataModelItem}>
                                    <Stack.Item>
                                        <FetchObjectsPanel

                                        />
                                    </Stack.Item>
                                    <Stack.Item grow>
                                        <ObjectListPanel
                                            onSelectionChanged={handleSelectionChanged}
                                        />
                                    </Stack.Item>
                                    <Stack.Item>
                                        <ObjectPanel
                                            appActions={appActions}
                                        />
                                    </Stack.Item>
                                </IfComp>
                            </Stack>
                        </Stack.Item>
                    </IfComp>
                    <IfComp cond={!dataModelDefinition.dataModelDefinition}>
                        <Stack.Item className={classNames.header}>
                            <div>Nahrávám...</div>
                        </Stack.Item>
                    </IfComp>
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

export default DataWindow;
